import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/components/seo";
import { breadcrumbSchema, serviceSchema } from "@/lib/schema";
import { pageMeta, services } from "@/content";
import { serviceDetails } from "@/content/details";
import { DetailPage } from "@/components/detail-page";

const ROUTE = "/services/strategic-bookkeeping";
export const Route = createFileRoute("/services/strategic-bookkeeping")({
  head: () => {
    const p = pageMeta(ROUTE)!;
    return routeHead(ROUTE, {
      jsonLd: [
        serviceSchema({ name: "Strategic Bookkeeping", description: p.description, url: ROUTE }),
        breadcrumbSchema([
          { name: "Home", item: "/" },
          { name: "Services", item: "/services" },
          { name: "Strategic Bookkeeping", item: ROUTE },
        ]),
      ],
    });
  },
  component: Page,
});
function Page() {
  const p = pageMeta(ROUTE)!;
  return (
    <DetailPage
      eyebrow="Service"
      heading={p.h1}
      description={p.description}
      content={serviceDetails[ROUTE]}
      related={services
        .filter((s) => s.href !== ROUTE)
        .map((s) => ({ label: s.name, href: s.href }))}
    />
  );
}
